module.exports = require("react");